import React from "react"

import Layout from "../../Components/Layout/Layout"
import PageTitle from "../../Components/Layout/PageTitle"
import { ProvisionContainer } from "../../Components/Style/Styles"
import { Policy } from "../../Config/Constant"

function ThirdParty() {
  return (
    <Layout isNav={false} isFooter={true} isSearch={true}>
      <PageTitle title={`${Policy.ThirdParty.title}`} />
      <ProvisionContainer>
        <h1>{Policy.ThirdParty.title}</h1>
        <div className="inner">{Policy.ThirdParty.content}</div>
      </ProvisionContainer>
    </Layout>
  )
}

export default ThirdParty
